var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('bottom-sheet', {
    attrs: {
      "title": "로그인",
      "maxWidth": "424",
      "fullscreen": "",
      "persistent": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref) {
        var attrs = _ref.attrs,
          on = _ref.on;
        return [_vm._t("activator", null, null, {
          attrs,
          on
        })];
      }
    }], null, true),
    model: {
      value: _vm.shows,
      callback: function ($$v) {
        _vm.shows = $$v;
      },
      expression: "shows"
    }
  }, [_c('v-layout', {
    staticClass: "bottom-sheet__contents",
    attrs: {
      "column": "",
      "justify-center": ""
    }
  }, [_c('v-img', {
    staticClass: "mh-40px mh-lg-60px w-100 mb-30 mb-lg-100",
    attrs: {
      "src": "/images/ci.svg",
      "contain": ""
    }
  }), _c('login-card', _vm._g({}, {
    loggedIn: _vm.loggedIn
  }))], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }